/* Bee Bella motion — bee-to-hive add-to-cart animation.
   Fires when an AJAX add-to-cart succeeds: a bee flies a curved path from the
   clicked button into the header beehive icon's entrance, the hive wiggles,
   and the count bubble pops. Transform/opacity only. No-ops entirely under
   prefers-reduced-motion or when GSAP is absent. */
(function () {
  'use strict';
  if (window.__bbBeeInit) { return; }
  window.__bbBeeInit = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var BTN_SELECTOR = '.bb-cgrid__vbtn, .bb-bs__vbtn, .bb-pdp__atc, .bb-pdp__sticky-btn, .bb3p__atc, .bbsb__atc';
  var MAX_BEES = 3;
  var liveBees = 0;
  var lastClick = null; // { el, x, y, t }

  var BEE_SVG =
    '<svg viewBox="0 0 100 120" width="46" height="55" xmlns="http://www.w3.org/2000/svg">' +
    '<g fill="#F6B60D">' +
    '<path d="M45 15 Q39 6 31 3" fill="none" stroke="#F6B60D" stroke-width="3" stroke-linecap="round"/>' +
    '<path d="M55 15 Q61 6 69 3" fill="none" stroke="#F6B60D" stroke-width="3" stroke-linecap="round"/>' +
    '<g class="bbbee__wl">' +
    '<ellipse cx="17" cy="27" rx="21" ry="9.5" transform="rotate(-28 17 27)"/>' +
    '<ellipse cx="20" cy="49" rx="13" ry="6" transform="rotate(-55 20 49)"/>' +
    '</g>' +
    '<g class="bbbee__wr">' +
    '<ellipse cx="83" cy="27" rx="21" ry="9.5" transform="rotate(28 83 27)"/>' +
    '<ellipse cx="80" cy="49" rx="13" ry="6" transform="rotate(55 80 49)"/>' +
    '</g>' +
    '<g fill="none" stroke="#F6B60D" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M40 40 L27 34 L20 25"/><path d="M60 40 L73 34 L80 25"/>' +
    '<path d="M39 48 L25 54 L17 64"/><path d="M61 48 L75 54 L83 64"/>' +
    '<path d="M41 55 L31 68 L26 81"/><path d="M59 55 L69 68 L74 81"/>' +
    '</g>' +
    '<circle cx="50" cy="21" r="9"/>' +
    '<ellipse cx="50" cy="43" rx="15.5" ry="14"/>' +
    '<defs><clipPath id="bbbee-abd"><path d="M50 55 C65 55 69 68 65 85 C61 100 54 109 50 112 C46 109 39 100 35 85 C31 68 35 55 50 55 Z"/></clipPath></defs>' +
    '<path d="M50 55 C65 55 69 68 65 85 C61 100 54 109 50 112 C46 109 39 100 35 85 C31 68 35 55 50 55 Z"/>' +
    '<g clip-path="url(#bbbee-abd)" fill="#3E3418">' +
    '<rect x="28" y="62" width="44" height="6.5"/>' +
    '<rect x="28" y="75" width="44" height="6.5"/>' +
    '<rect x="28" y="88" width="44" height="6.5"/>' +
    '<rect x="28" y="100" width="44" height="6"/>' +
    '</g>' +
    '</g></svg>';

  function visibleHive() {
    var hives = document.querySelectorAll('.beehive-cart-wrapper');
    for (var i = 0; i < hives.length; i++) {
      var h = hives[i];
      if (h.offsetParent !== null && h.getBoundingClientRect().width > 0) { return h; }
    }
    return null;
  }

  // Remember which button was tapped (capture phase so we never depend on
  // the sections' own handlers).
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) { return; } // sticky bar proxies a programmatic click to the main button
    var btn = e.target.closest && e.target.closest(BTN_SELECTOR);
    if (btn && !btn.disabled) {
      var r = btn.getBoundingClientRect();
      lastClick = { x: r.left + r.width / 2, y: r.top + r.height / 2, t: Date.now() };
    }
  }, true);

  // Fire on a successful AJAX /cart/add — coexists with other fetch patches.
  if (window.fetch && !window.__bbBeeFetch) {
    window.__bbBeeFetch = true;
    var of = window.fetch;
    window.fetch = function () {
      var a = arguments;
      var p = of.apply(this, a);
      try {
        var u = (a[0] && a[0].url) || a[0] || '';
        if (typeof u === 'string' && /\/cart\/add/.test(u)) {
          p.then(function (res) { if (res && res.ok) { onAdded(); } });
        }
      } catch (err) {}
      return p;
    };
  }

  function onAdded() {
    if (!lastClick || Date.now() - lastClick.t > 4000) { return; }
    var origin = lastClick;
    lastClick = null;
    var hive = visibleHive();
    if (!hive) { return; }
    // document.hidden: rAF is suspended in background tabs — a bee would just
    // freeze mid-air until the tab is foregrounded. Skip to the counter pop.
    if (reduced || !window.gsap || liveBees >= MAX_BEES || document.hidden) {
      popCount(hive, true);
      return;
    }
    flyBee(origin, hive);
  }

  function popCount(hive, soloPop) {
    var bubble = hive.querySelector('.js-cart-count');
    if (!bubble) { return; }
    if (window.gsap && !reduced) {
      gsap.fromTo(bubble, { scale: 1 }, {
        scale: 1.55, duration: 0.16, ease: 'power2.out', yoyo: true, repeat: 1,
        transformOrigin: '50% 50%'
      });
    }
    if (soloPop || reduced) { return; }
  }

  function wiggleHive(hive) {
    var icon = hive.querySelector('.beehive-icon') || hive;
    gsap.timeline()
      .to(icon, { scaleX: 1.14, scaleY: 0.88, duration: 0.1, ease: 'power2.out', transformOrigin: '50% 100%' })
      .to(icon, { scaleX: 0.94, scaleY: 1.06, duration: 0.1 })
      .to(icon, { scaleX: 1, scaleY: 1, rotation: -5, duration: 0.09 })
      .to(icon, { rotation: 4, duration: 0.09 })
      .to(icon, { rotation: 0, duration: 0.12, ease: 'back.out(3)' });
  }

  function flyBee(origin, hive) {
    if (window.MotionPathPlugin && !window.__bbBeeMP) {
      gsap.registerPlugin(window.MotionPathPlugin);
      window.__bbBeeMP = true;
    }

    var hr = hive.getBoundingClientRect();
    // Aim for the hive's entrance hole (bottom-center of the icon).
    var dest = { x: hr.left + hr.width / 2, y: hr.top + hr.height * 0.88 };

    document.dispatchEvent(new CustomEvent('bbbee:flight'));
    var bee = document.createElement('div');
    bee.className = 'bbbee';
    bee.setAttribute('aria-hidden', 'true');
    bee.style.cssText = 'position:fixed;left:0;top:0;z-index:99999;pointer-events:none;will-change:transform;';
    bee.innerHTML = BEE_SVG;
    document.body.appendChild(bee);
    liveBees++;

    var wingL = bee.querySelector('.bbbee__wl');
    var wingR = bee.querySelector('.bbbee__wr');
    var flutter = gsap.timeline({ repeat: -1, yoyo: true })
      .to(wingL, { rotation: -24, svgOrigin: '38 38', duration: 0.07, ease: 'power1.inOut' }, 0)
      .to(wingR, { rotation: 24, svgOrigin: '62 38', duration: 0.07, ease: 'power1.inOut' }, 0);

    // Curved path: rise above the straight line, with a little lateral drift
    // so consecutive bees don't fly identical routes.
    var midX = (origin.x + dest.x) / 2 + (Math.random() * 80 - 40);
    var midY = Math.min(origin.y, dest.y) - (130 + Math.random() * 80);
    var dur = 1.45 + Math.random() * 0.3;

    gsap.timeline({
      onComplete: function () {
        flutter.kill();
        bee.remove();
        liveBees--;
      }
    })
      .set(bee, { x: origin.x - 23, y: origin.y - 27, scale: 0.2, opacity: 0 })
      .to(bee, { scale: 1, opacity: 1, duration: 0.22, ease: 'back.out(2)' })
      .to(bee, {
        motionPath: {
          path: [
            { x: origin.x - 23, y: origin.y - 27 },
            { x: midX, y: midY },
            { x: dest.x - 23, y: dest.y - 27 }
          ],
          curviness: 1.4,
          autoRotate: 90
        },
        duration: dur,
        ease: 'power1.inOut'
      }, '>-0.02')
      .to(bee, { scale: 0.18, opacity: 0, duration: 0.2, ease: 'power2.in' }, '>-0.16')
      .add(function () {
        wiggleHive(hive);
        popCount(hive, false);
        document.dispatchEvent(new CustomEvent('bbbee:landed'));
      }, '>-0.05');
  }

  // Scroll-in reveals: honeycomb cells + product cards rise gently into place.
  // Professional restraint: 18px travel, 0.6s, no bounce, plays once, and only
  // elements still below the fold are touched (zero flash on first paint).
  (function () {
    if (reduced || !window.gsap || !('IntersectionObserver' in window)) { return; }
    var els = document.querySelectorAll('.bb-hc__cell, .bb-bs__card, .bb-cgrid__card');
    var queue = [];
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.width > 0 && r.top > window.innerHeight * 0.92) { queue.push(els[i]); }
    }
    if (!queue.length) { return; }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) { continue; }
        var el = entries[i].target;
        io.unobserve(el);
        var idx = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        gsap.to(el, {
          opacity: 1, y: 0, scale: 1,
          duration: 0.6, ease: 'power2.out',
          delay: (idx % 4) * 0.07,
          onComplete: (function (node) {
            return function () { gsap.set(node, { clearProps: 'all' }); };
          })(el)
        });
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    for (var j = 0; j < queue.length; j++) {
      var hex = queue[j].classList.contains('bb-hc__cell');
      gsap.set(queue[j], { opacity: 0, y: 18, scale: hex ? 0.93 : 1 });
      io.observe(queue[j]);
    }
  })();

  // Ambient hero bee: one slow drift across the homepage hero, behind the
  // headline, once per session. Desktop only; skipped for reduced-motion,
  // hidden tabs, and small screens. Subtlety is the whole point.
  (function () {
    if (reduced || !window.gsap || document.hidden) { return; }
    if (window.innerWidth < 990) { return; }
    var hero = document.querySelector('.bb-hero__media');
    if (!hero) { return; }
    try {
      if (sessionStorage.getItem('bbAmbientBee')) { return; }
      sessionStorage.setItem('bbAmbientBee', '1');
    } catch (e) {}

    setTimeout(function () {
      if (document.hidden) { return; }
      if (window.MotionPathPlugin && !window.__bbBeeMP) {
        gsap.registerPlugin(window.MotionPathPlugin);
        window.__bbBeeMP = true;
      }
      var w = hero.clientWidth;
      var h = hero.clientHeight;
      if (!w || !h) { return; }

      var bee = document.createElement('div');
      bee.className = 'bbbee bbbee--ambient';
      bee.setAttribute('aria-hidden', 'true');
      // z-index 1: above the photo/scrim, below the hero text (z-index 2).
      bee.style.cssText = 'position:absolute;left:0;top:0;z-index:1;pointer-events:none;will-change:transform;opacity:0;';
      bee.innerHTML = BEE_SVG;
      bee.firstChild.setAttribute('width', '32');
      bee.firstChild.setAttribute('height', '38');
      hero.appendChild(bee);

      var wingL = bee.querySelector('.bbbee__wl');
      var wingR = bee.querySelector('.bbbee__wr');
      var flutter = gsap.timeline({ repeat: -1, yoyo: true })
        .to(wingL, { rotation: -24, svgOrigin: '38 38', duration: 0.07, ease: 'power1.inOut' }, 0)
        .to(wingR, { rotation: 24, svgOrigin: '62 38', duration: 0.07, ease: 'power1.inOut' }, 0);

      gsap.timeline({
        onComplete: function () { flutter.kill(); bee.remove(); }
      })
        .to(bee, {
          motionPath: {
            path: [
              { x: -50, y: h * 0.42 },
              { x: w * 0.22, y: h * 0.55 },
              { x: w * 0.45, y: h * 0.34 },
              { x: w * 0.72, y: h * 0.48 },
              { x: w + 60, y: h * 0.26 }
            ],
            curviness: 1.3,
            autoRotate: 90
          },
          duration: 8,
          ease: 'none'
        }, 0)
        .to(bee, { opacity: 0.9, duration: 0.9, ease: 'power1.in' }, 0.1)
        .to(bee, { opacity: 0, duration: 1.1, ease: 'power1.out' }, 6.8);
    }, 1400);
  })();

  // Debug handle: window.__bbBee.test() flies a bee from screen-center.
  window.__bbBee = {
    test: function () {
      var hive = visibleHive();
      if (!hive || !window.gsap) { return 'no hive or gsap'; }
      flyBee({ x: window.innerWidth / 2, y: window.innerHeight * 0.7, t: Date.now() }, hive);
      return 'flying';
    }
  };
})();
